import { useQuery } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getKickstartSurveyList } from 'services/engagement';

import type { SurveyList } from './types';

export const useGetSurveyList = () =>
  useQuery<SurveyList>({ queryKey: [REACT_QUERY_KEYS.engagement.getSurveyList], queryFn: getKickstartSurveyList });
